import dayjs, { Dayjs } from 'dayjs'
import type { ReleaseWallClock } from 'src/interfaces/invoice'

/**
 * The Day.js boundary for the MUI X pickers (`AdapterDayjs`), and nothing more.
 *
 * The picker's Dayjs value is used only as a container for a Central Time wall clock: its
 * calendar fields are read and written as-is and never interpreted in the browser's zone. An
 * admin in Lisbon who picks 9:00 gets 9:00 Central, and all zone math happens in Luxon
 * (`utils/paymentReleaseTime.ts`).
 */
export const wallClockFromPicker = (value: Dayjs): ReleaseWallClock => {
  return {
    year: value.year(),
    // Day.js months are 0-11; `ReleaseWallClock` follows Luxon's 1-12.
    month: value.month() + 1,
    day: value.date(),
    hour: value.hour(),
    minute: value.minute(),
  }
}

/**
 * One constructor call, not chained setters from "today": `.month(1)` on Jan 31 would roll into
 * March before `.date()` ran.
 */
export const pickerValueFromWallClock = (wallClock: ReleaseWallClock): Dayjs => {
  return dayjs(
    new Date(wallClock.year, wallClock.month - 1, wallClock.day, wallClock.hour, wallClock.minute),
  )
}

export const isValidPickerValue = (value: unknown): value is Dayjs => {
  return dayjs.isDayjs(value) && value.isValid()
}
